import { useSelector } from 'react-redux';
import { getForceExpandedItems } from '../selectors';

/**
 * Hook to get the force expanded state for a specific item
 * @param itemId - The ID of the item to check for force expansion
 * @returns boolean indicating if the item should be force expanded
 */
export const useForceExpanded = (itemId: string | undefined): boolean => {
    const forceExpandedItems = useSelector(getForceExpandedItems);
    return itemId ? forceExpandedItems[itemId] : false;
};
